import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Legal.scss';
import SEO from '../../components/SEO';
const TermsOfService = () => {
    const { t } = useTranslation();
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div className="kanem-legal-page">
            <SEO title="Conditions d'utilisation" description="Conditions d'utilisation des services KANEM. Modalités, paiements et responsabilités." url="/conditions-utilisation" />

            <div className="kanem-legal-hero">
                <div className="kanem-grain"></div>
                <div className="kanem-legal-hero-content">
                    <p className="kanem-eyebrow">{t('legal.eyebrow')}</p>
                    <h1 className="kanem-legal-title">{t('legal.terms_title')}</h1>
                    <p className="kanem-legal-date">{t('legal.last_updated')}</p>
                </div>
            </div>

            <div className="kanem-legal-body">
                <div className="kanem-legal-inner">

                    <section className="kanem-legal-section">
                        <h2>{t('legal.terms.s1_title')}</h2>
                        <p>{t('legal.terms.s1_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.terms.s2_title')}</h2>
                        <p>{t('legal.terms.s2_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.terms.s3_title')}</h2>
                        <p>{t('legal.terms.s3_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.terms.s4_title')}</h2>
                        <p>{t('legal.terms.s4_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.terms.s5_title')}</h2>
                        <p>{t('legal.terms.s5_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.terms.s6_title')}</h2>
                        <p>{t('legal.terms.s6_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.terms.s7_title')}</h2>
                        <p>{t('legal.terms.s7_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.terms.s8_title')}</h2>
                        <p>{t('legal.terms.s8_desc')} <Link to="/contact">{t('legal.terms.s8_link')}</Link>.</p>
                    </section>

                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
